import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <defs>
      <path
        id="icons-file-pdf_svg__a"
        d="M18.8 6V4c0-1.1-.945-2-2.1-2H4.1C2.945 2 2 2.9 2 4v16c0 1.1.945 2 2.1 2h12.6c1.155 0 2.1-.9 2.1-2v-2h-2.1v2H4.1V4h12.6v2h2.1zM6.2 9.4h2.625c1.26 0 2.205.8 2.205 2s-.84 2-2.205 2h-1.05V15H6.2V9.4zm2.52 1.4h-.945V12h.945c.42 0 .63-.3.63-.6.105-.4-.21-.6-.63-.6zm3.36-1.4h2.31c1.785 0 3.15 1.2 3.15 2.8 0 1.6-1.26 2.8-3.15 2.8h-2.31V9.4zm2.31 1.4h-.63v2.9h.63c.84 0 1.47-.6 1.47-1.4 0-.8-.63-1.5-1.47-1.5zm4.095-1.4H23v1.4h-2.94v.9h2.31V13h-2.31v2h-1.575V9.4z"
      />
    </defs>
    <use
      fill="currentColor"
      fillRule="evenodd"
      xlinkHref="#icons-file-pdf_svg__a"
    />
  </svg>
);
